import { Skeleton, SkeletonCards } from '@/components/ui/Skeleton';

/**
 * Route-level Suspense fallback. Mimics the shape of a typical page (header
 * + stats + content) so the UI doesn't jump when the lazy chunk arrives.
 */
export function RouteFallback() {
  return (
    <div className="full-center fade-in" style={{ minHeight: '60vh', width: '100%' }}>
      <div style={{ width: '100%', maxWidth: 1200, padding: '0 1rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, gap: 12 }}>
          <div style={{ display: 'grid', gap: 8, minWidth: 0, flex: 1 }}>
            <Skeleton shape="line" width="40%" height={24} />
            <Skeleton shape="line" width="22%" height={12} />
          </div>
          <Skeleton shape="line" width={84} height={36} />
        </div>
        <SkeletonCards count={4} />
        <div style={{ height: 18 }} />
        <div className="card" style={{ marginBottom: 0 }}>
          <Skeleton lines={5} gap="0.6rem" />
        </div>
      </div>
    </div>
  );
}
